import { BreakpointsPx, Fit } from '@jsmdg/imgix';

export const PRODUCT_IMG_DIMENSIONS = {
    [BreakpointsPx.xs]: { width: 458, height: 301 }, // 3:2
    [BreakpointsPx.xl]: { width: 735, height: 483 }, // 3:2
};

export const PRODUCT_IMG_DIMENSIONS_PREVIEW = {
    [BreakpointsPx.xs]: { width: 343, height: 257, fit: Fit.facearea }, // 4:3
};

export const GALLERY_IMAGES_PREVIEW_DIMENSIONS = { width: 150, height: 100 };
